import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import ReactMarkdown from 'react-markdown';
import Fuse from "fuse.js";
import axios from 'axios';
import UploadWrapper from './UploadWrapper.js';
import CreateClient from './CreateClient.js';
import CreateOrder from './CreateOrder.js';
import { useAuthContext } from '../contexts/AuthContext.js';
import { useNewChatContext } from '../contexts/NewChatContext.js';
import CreateMeeting from "./CreateMeeting.js";
import useDragAndDrop from "../hooks/UseDragAndDrop.js";
import AILoadingText from "./AILoadingText.js";
import { useUploadContext } from "../contexts/UploadContext.js";

const NewChatForm = ({
  isSidebarVisible, setIsSidebarVisible,
  setActiveComponent, setSelectedConversation,
  // selectedConversation = null
  uploadedFiles, setUploadedFiles,
}) => {
  const { AuthData, updateAuthData, user, setUser } = useAuthContext();
  const [selectedComponent, setSelectedComponent] = useState(null); // 管理顯示的元件
  const [input, setInput] = useState("");
  const [component, setComponent] = useState(null);
  const [azureOpenAIResponse, setAzureOpenAIResponse] = useState([]);
  const [flaskLoading, setFlaskLoading] = useState(null);
  const { setNewChatInput, newChatId, setNewChatId } = useNewChatContext();
  const textareaRef = useRef(null);
  const { uploadAttachments, updateUploadAttachments, setUploadAttachments } = useUploadContext();

  // ⭐ 自動調整高度
  useLayoutEffect(() => {
    const el = textareaRef.current;
    if (!el) return;

    el.style.height = "auto";               // 先重置
    el.style.height = `${el.scrollHeight}px`; // 再撐高 // 內容實際高度
  }, [input]);

  const handleKeyDown = (e) => {
    console.log("keydown event:", e);
    if (e.isComposing || e.keyCode === 229) return;
    // Enter 送出、Shift+Enter 換行
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const options = {
    includeScore: true,
    threshold: 0.4,
  };

  const keywords = {
    "新增客戶": ["新增客戶", "創建客戶", "建立客戶", "Client", "dk4cj4"],
    "新增訂單": ["新增訂單", "創建訂單", "建立訂單", "Order", "2/u420 "],
    "上傳": ["上傳", "檔案", "提交檔案", "傳檔", "Upload", "g;4tj06"],
    "新增會議": ["新增會議", "創建會議", "建立會議", "Meeting", "cjo4u4"],
    // "檔名資料": ["檔案", "文件", "查找檔案", "搜尋檔名"],
  };

  useEffect(()=>{
    setUploadAttachments([])
  },[])

  // 監聽 component 的變化，自動顯示/隱藏側邊欄
  useEffect(() => {
    if (component != null) {
      setIsSidebarVisible(true); // 顯示側邊欄
    } else {
      setIsSidebarVisible(false); // 隱藏側邊欄
    }
  }, [component]); // 當 input 改變時執行

  useEffect(() => {
    console.log(azureOpenAIResponse);
  }, [azureOpenAIResponse])

  // useEffect(() => {
  //   setSelectedConversation(null);
  //   setNewChatId(null);
  //   setNewChatInput(null);
  // }, [])

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim()) return alert("請輸入文字！");
    const newId = await handleCreate();
    setNewChatId(newId);
    setNewChatInput(input);
    setActiveComponent("ConversationWrapper")
    console.log(input);
  };

  const handleCreate = async () => {
    try {
      const res = await fetch('http://localhost:5000/create-conversations', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: user.user_id,
          user_input: input
        })
      });
      const data = await res.json();
      console.log("new conversation_id:", data);
      return data.conversation.id;

      // setResult(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    const text = e.target.value;
    let matchedComponent = null;

    for (const [key, words] of Object.entries(keywords)) {
      const fuse = new Fuse(words, options);
      const result = fuse.search(text);
      if (result.length > 0) {
        if (key === "新增客戶") matchedComponent = <CreateClient />;
        else if (key === "新增訂單") matchedComponent = <CreateOrder />;
        else if (key === "上傳") matchedComponent = <UploadWrapper />;
        else if (key === "新增會議") matchedComponent = <CreateMeeting />;
        // else if (key === "檔名資料") {
        //   // 假設 fetchFileUrls 返回檔案列表，並更新到某個元件中
        //   matchedComponent = <div>檔名相關搜尋結果</div>;
        // }
        break;
      }
    }

    setComponent(matchedComponent);
    setInput(e.target.value);
  };


  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };


  const handleFileDrop = (files) => {
    // const newEntries = files.map((file) => ({
    //   fileName: file.name,
    //   file, // 將檔案物件存入
    //   access: "", // 初始為空，submit 時再更新
    //   client: "",
    //   project: "",
    // }));
    // updateUploadData(newEntries); // 將新檔案加入 context
    const newEntries = files.map((file) => ({
      fileName: file.name,
      file, // 儲存檔案物件
      // ...commonData, // 即時同步表單資料
    }));
    updateUploadAttachments(newEntries); // 更新 Context，覆蓋舊檔案
    console.log(uploadAttachments);
  };


  return (
    <>
      {/* <br /> */}
      <div className='chat-log'>
        {azureOpenAIResponse &&
          azureOpenAIResponse.map((msg, index) => (
            <div
              key={index}
              className={`${msg.role === 'user' ? 'question' : ''
                }`}
            >
              <div
                className={`${msg.role === 'user'
                  ? ''
                  : 'response'
                  }`}
              >
                <ReactMarkdown>{msg.content}</ReactMarkdown>
              </div>
            </div>
          )
          )}
        {flaskLoading ? <AILoadingText /> : ""}
        {/* 根據不同的回應顯示不同的內容 */}
      </div>

      <form className={`create-form ${isSidebarVisible ? 'sidebar-open' : ''}`} onSubmit={handleSubmit}>
        <div className="message-area">
          {/* <input
        type="text"
        value={content}
        onChange={(e) => { setContent(e.target.value) }}
        placeholder="請輸入訊息"
      /> */}
          <div className="message-attachments">
            {uploadAttachments &&
              uploadAttachments.map((uploadAttachment) => {
                return (
                  <div className="message-attachment">
                    {uploadAttachment.fileName}
                  </div>
                )
              })
            }
          </div>
          <div className="message-row">
            {/* <button className="composer-btn" type="button">➕</button> */}
            <input
              type="file"
              multiple
              // webkitdirectory="true"
              // directory="true"
              onChange={(e) => handleFileDrop(Array.from(e.target.files))}
              style={{ display: "none" }}
              id="fileInput"
            />
            <label
              htmlFor="fileInput"
              className="composer-btn"
            >
              ➕
              {/* 選擇檔案
              <img src='./arrow04.png' style={{
                width: "20%",
              }}></img> */}
            </label>


            <textarea
              ref={textareaRef}
              type="text"
              value={input}
              rows={1}
              // onChange={(e) => setInput(e.target.value)}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              placeholder="Enter your message..."
              // className="chat-textarea"
            />
            {/* <input type="file"></input> */}

            <button type="submit">
              <img className="sent-message" src="./sent.png" alt="送出" />
            </button>
          </div>
        </div>
        <div className="toggle-area">
          {/* 固定在畫面右邊的按鈕 */}
          <button
            type="button" className="toggle-button" onClick={toggleSidebar}>
            {isSidebarVisible ? ">>" : "<<"}
          </button>
        </div>
      </form>

      {/* 可顯示/隱藏的右側區塊 */}
      <div className={`sidebar ${isSidebarVisible ? "visible" : "hidden"}`}>
        {/* {renderComponent()} */}
        {component}
      </div>

      <div style={{ marginTop: "20px" }}>{selectedComponent}</div>
    </>
  );
}

export default NewChatForm;
